import { useState, useEffect, useContext } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { UserContext } from "@/contexts/UserContext/UserContext";
import { LoginHandler } from "@/contexts/UserContext/types";

export const onAuthenticationSuccess = async (
  token: string,
  login: LoginHandler,
  clientType: "consumer" | "banker"
) => {
  login(token, clientType);
};

export const useLoginCallback = (clientType: "consumer" | "banker") => {
  const { error, user, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const { login } = useContext(UserContext);
  const [messages, setMessages] = useState<string>();

  const onAuthenticationFailure = (error: unknown) => {
    console.error("Error handling authentication:", error);
    setMessages(error as string);
  };

  useEffect(() => {
    if (error) {
      onAuthenticationFailure(error);
    }

    if (isAuthenticated && user) {
      getAccessTokenSilently()
        .then((token) => {
          onAuthenticationSuccess(token, login, clientType);
        })
        .catch((e) => {
          onAuthenticationFailure(e);
        });
    }
  }, [isAuthenticated, user, error, getAccessTokenSilently, login, clientType]);

  return {
    messages,
    error,
    user,
    isAuthenticated,
  };
};
